import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import StandardLayout from '../../layouts/StandardLayout';
import Form from '../../common/form/Form';
import FormInput from '../../common/form/Input';
import * as authApi from '../../../api/Auth';
import * as identity from '../../../utilities/identity';
import { browserHistory } from '../../../utilities/history';
import LoadingOverlay from '../../common/LoadingOverlay';

interface State {
    username: string;
    wasFormValidated: boolean;
    errorMessage: string;
    isLoading: boolean;
}

class ForgotPasswordPage extends React.Component<RouteComponentProps<{}>, State> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.state = {
            username: '',
            errorMessage: '',
            wasFormValidated: false,
            isLoading: false
        };

        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        // users are logged out before registering
        identity.clearToken();
    }

    render() {
        return (
            <div>
                <LoadingOverlay show={this.state.isLoading} inBootstrapColumn={false} />
                <StandardLayout>
                    <Form
                        wasFormValidated={this.state.wasFormValidated}
                        inBootstrapColumn={false}
                        submitButtonText="Reset Password"
                        onSubmit={this.handleSubmit}
                        errorMessage={this.state.errorMessage}
                        onFormValidated={() => this.setState({ wasFormValidated: true })}
                        divClassname="content container col col-md-8 col-lg-6 col-xl-4"
                    >
                        <h2 className="text-center">Forgot your Password?</h2>
                        <FormInput
                            inputProps={{
                                id: 'username',
                                name: 'username',
                                type: 'username',
                                value: this.state.username,
                                required: true
                            }}
                            labelProps={{
                                labelText: 'Username'
                            }}
                            onChange={this.inputChangeHandler}
                        />
                    </Form>
                </StandardLayout>
            </div>
        );
    }

    private inputChangeHandler(inputName: string, newValue: string) {
        this.setState({
            ...this.state,
            [inputName]: newValue
        });
    }

    private async handleSubmit() {
        this.setState({
            isLoading: true
        });
        var result = await authApi.requestPasswordReset(this.state.username);
        if (result.success) {
            browserHistory.push('/forgotpasswordconfirmation');
        } else if (result.error) {
            this.setState({
                errorMessage: result.error,
                isLoading: false
            });
        }
    }
}

export default withRouter<RouteComponentProps<{}>>(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/components/pages/auth/ForgotPasswordPage.tsx